module.exports = __webpack_public_path__ + "img/t.63c9bd2f.jpg";